// for DEV
export const DEV_CONFIGS = {
  backend_port: ":5000", // define the backend port
  backend_url_path: "/", // custom backend url path if necessary. default is "/"
  route_basename: "/", // for defining the base route for BrowserRouter
};
